import type { ZnglyInfo_Settings_Fragment$data } from '@/graphql/queries/ZnglyInfo.query';
import { useEffect } from 'react';
import { create } from 'zustand';

const initSettingsStore = Object.freeze({
  queryRef: null as ZnglyInfo_Settings_Fragment$data | null,
  showTopbar: true as boolean,
});

type SettingsStore = typeof initSettingsStore & {
  reset: () => void;
};

export const useSettingsStore = create<SettingsStore>((set) => ({
  ...initSettingsStore,
  reset: () => set({ ...initSettingsStore }),
}));

export const useNoTopbar = () => {
  useEffect(() => {
    useSettingsStore.setState({ showTopbar: false });

    return () => {
      useSettingsStore.setState({ showTopbar: true });
    };
  }, []);
};
